import { useNavigate } from "react-router-dom";
import { HEALTH_STYLE, STAGE_MAP } from "@/lib/constants";
import { Clock, Sparkles, User } from "lucide-react";

export default function IdeaCard({ idea }) {
  const navigate = useNavigate();
  const health = HEALTH_STYLE[idea.health] || HEALTH_STYLE.idle;
  const rel = idea.ai?.relevance?.relevance_score;
  const sc = idea.ai?.scorecard?.overall;

  return (
    <button
      data-testid={`idea-card-${idea.id}`}
      onClick={() => navigate(`/ideas/${idea.id}`)}
      className="w-full text-left border border-border bg-[#111111] rounded-sm p-3 hover:border-white/25 hover:bg-white/[0.04] transition-colors duration-200 group"
    >
      <div className="flex items-start justify-between gap-2">
        <h4 className="font-semibold text-sm leading-snug group-hover:text-white">{idea.title}</h4>
        <span className={`shrink-0 font-mono text-[9px] uppercase tracking-wider px-1.5 py-0.5 border rounded-sm ${health.cls}`}>
          {health.label}
        </span>
      </div>

      <p className="text-xs text-muted-foreground mt-1.5 line-clamp-2">{idea.description}</p>

      {idea.tags?.length > 0 && (
        <div className="flex flex-wrap gap-1 mt-2">
          {idea.tags.slice(0, 3).map((t) => (
            <span key={t} className="font-mono text-[9px] px-1.5 py-0.5 bg-secondary rounded-sm text-muted-foreground">
              {t}
            </span>
          ))}
        </div>
      )}

      <div className="flex items-center justify-between mt-3 pt-2 border-t border-border text-[10px] text-muted-foreground font-mono">
        <span className="flex items-center gap-1"><User className="w-3 h-3" />{idea.submitter}</span>
        <span className="flex items-center gap-1"><Clock className="w-3 h-3" />{idea.stage_age_days}d</span>
      </div>

      {(rel != null || sc != null) && (
        <div className="flex items-center gap-1.5 mt-2 text-[10px] text-ai font-mono">
          <Sparkles className="w-3 h-3" />
          {sc != null ? `Scorecard ${sc}%` : `Relevance ${rel}`}
        </div>
      )}
    </button>
  );
}
